import { useState, useEffect } from "react";
import { ContactForm } from "./components/ContactForm";
import { validate } from "../../../utils/form-functions";
import { InfoBox } from "../../components/form/InfoBox";
import { sendGaEvent, sendLinkedInConversion } from "../../../../config/userTracking";
import { userApi } from "../../../../api/userApi";
import { formAttribution } from "../../../../utils/formAttribution";
import clsx from "clsx";

import { LandingSourceCarousel } from "../../LandingTemplate/components/LandingSourceCarousel";
import Link from "next/link";
import { linksConstants } from "../../../../constants/linksConstants";

export const DiscoveryForm = ({ data, type, className }) => {
  const [modalOpen, changeModalOpen] = useState(false);
  const [errorModalOpen, changeErrorModalOpen] = useState(false);
  const [consent, changeConsent] = useState(false);
  const [formData, changeFormData] = useState({});
  const [errors, changeErrors] = useState({});
  const [sending, changeSending] = useState(false);
  const [linkedInCookie, setLinkedInCookie] = useState(null);

  useEffect(() => {
    setLinkedInCookie(localStorage.getItem("li_fat_id"));
  }, []);

  const changeData = (e, data) => {
    let newFormData = { ...formData };
    newFormData[data.id] = e;
    changeFormData(newFormData);
  };

  const preparedData = () => {
    let preparedData = formAttribution(
      type === "report"
        ? "Data Discovery Report Request"
        : type === "contact"
        ? "Contact Form"
        : "Demo Request Form",
    );
    data.fields.forEach(field => {
      preparedData[field.id] = formData[field.id];
    });
    return preparedData;
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (validate({ type, formData, data, changeErrors, consent }) === true) {
      changeSending(true);
      const dataToSend = {
        type,
        formValues: preparedData(),
      };
      linkedInCookie && sendLinkedInConversion();

      if (type === "contact") {
        sendGaEvent(
          {
            action: "Form Submission",
            category: "Contact",
          },
          formData.email,
        );
      }
      if (type === "request") {
        sendGaEvent(
          {
            action: "Form Submission",
            category: "Request Demo",
          },
          formData.email,
        );
      }
      try {
        await userApi.sendFrontForm(dataToSend);
        changeModalOpen(true);
        changeSending(false);
      } catch (e) {
        changeErrorModalOpen(true);
        changeSending(false);
      }
    }
  };

  useEffect(() => {
    let newFormData = {};
    data.fields.forEach(field => {
      newFormData[field.id] = "";
    });
    changeFormData(newFormData);
  }, []);

  return (
    <>
      {modalOpen && <InfoBox closeModal={() => changeModalOpen(false)} />}
      {errorModalOpen && (
        <InfoBox closeModal={() => changeErrorModalOpen(false)} type="Error" fromContact={true} />
      )}
      {["contact", "request"].includes(type) &&
        typeof formData[data.fields[0].id] !== "undefined" && (
          <ContactForm
            data={data}
            formData={formData}
            changeData={changeData}
            errors={errors}
            consent={consent}
            className={className}
            changeConsent={changeConsent}
            handleSubmit={handleSubmit}
            sending={sending}
            type={type}
          />
        )}
    </>
  );
};

export const DiscoveryFormTemplate = ({ dataSources, data, type }) => {
  return (
    <section
      className={clsx(
        "LandingHero-background",
        "LandingHero-background-purple",
        "DiscoveryFormTemplate",
        "DiscoveryFormTemplate-WithCarousel",
      )}
    >
      <LandingSourceCarousel backgroundColor="teal" data={dataSources} />
      <div
        className={clsx(
          "DiscoveryFormTemplate",
          "DiscoveryFormTemplate-WithCarousel",
          "LandingHero",
          "LandingHero-align-left",
          "LandingHero-type-platform-sign-up",
        )}
        id="hero"
      >
        <section className="section-layout">
          <h1 className="LandingHero-title">
            {type === "request" ? "See it for yourself" : "Get in touch"}
          </h1>
          <p className="LandingHero-subtitle">
            {type === "request"
              ? "Meet our sales and solution consultants to learn how our product helps enterprises unlock the power of external data."
              : "Have a question or need more information about Demyst? Please enter your information and describe your inquiry, and someone will get back to you as soon as they can."}
          </p>

          {type === "contact" && (
            <p className="LandingHero-subtitle">
              Looking to apply to Demyst? Visit our{" "}
              <Link href={linksConstants.CAREERS}>careers page</Link>.
            </p>
          )}
        </section>
        <section className="section-layout">
          <DiscoveryForm data={data} type={type} />
        </section>
      </div>
    </section>
  );
};
